module.exports = __webpack_public_path__ + "img/po-title-sub.24c78734.png";